module.exports = __webpack_public_path__ + "img/ic_daily_checkins.bea8e9f0.png";